import React, { useEffect, useState } from 'react'
import _ from 'lodash'
import clsx from 'clsx'
import { Box, Typography } from '@material-ui/core'
import { vppService } from '../../Services'
import { useStyles } from './styles'

const ZIP = 'ZIP'
const ZIPCODE = 'ZIP/POSTAL CODE'
function GroupingCriteria(props) {
  const classes = useStyles()
  const [groupingDetails, setGroupingDetails] = useState({})

  useEffect(() => {
    const { isEdit, vppDetails } = props
    if (isEdit) {
      const grpCriteria = _.get(vppDetails.query, 'tags', [])
      const listItem = Object.entries(grpCriteria).map(([key, value]) => ({ grpKey: key, grpValue: value }))

      setGroupingDetails({
        grpCriteria: listItem,
        total_systems: _.get(vppDetails, 'total_systems', 0),
        total_capacity: _.get(vppDetails, 'total_capacity', 0),
        total_power: _.get(vppDetails, 'total_power', 0),
        committed_energy: _.get(vppDetails, 'committed_energy', 0)
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.isEdit, props.vppDetails])

  useEffect(() => {
    const { programId, grpCriteria } = props

    if (programId && grpCriteria) {
      const isValid = !grpCriteria.some(obj => (
        _.isEmpty(obj.grpKey) || _.isEmpty(obj.grpValue)
      ))

      if (isValid) {
        const groupingTag = grpCriteria
        const additionalProps = {}
        groupingTag.forEach((tagObj) => {
          additionalProps[tagObj.grpKey] = _.isArray(tagObj.grpValue) ? tagObj.grpValue : (tagObj.grpValue).split(',').map(str => str.trim())
        })

        const params = {
          operator: "AND",
          tags: additionalProps
        }

        props.accountId && vppService.putVppQuery(programId, params, props.accountId)
          .then((response) => {
            setGroupingDetails({
              grpCriteria: grpCriteria || [],
              total_systems: _.get(response, 'total_systems', 0),
              total_capacity: _.get(response, 'total_capacity', 0)?.toFixed(2),
              total_power: _.get(response, 'total_power', 0)?.toFixed(2),
              nameplate_power: _.get(response, 'nameplate_power', 0)?.toFixed(2),
              committed_energy: _.get(response, 'committed_energy', 0)?.toFixed(2)
            })
          })
          .catch(() => { })
      }
    } else {
      setGroupingDetails({
        grpCriteria: grpCriteria || [],
        total_systems: 0,
        total_capacity: 0,
        total_power: 0,
        nameplate_power: 0,
        committed_energy: 0
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.programId, props.grpCriteria])

  const capitalize = (text) => {
    if (typeof text !== 'string') return ''
    return text.charAt(0).toUpperCase() + text.slice(1)
  }

  const renderGroupCriteria = () => {
    const groupingTag = _.get(groupingDetails, 'grpCriteria', [])
    let groupingTextView = ''

    !_.isEmpty(groupingTag) && groupingTag.forEach((obj, index) => {
      if (obj.grpKey && obj.grpValue) {
        let valuesList = _.isArray(obj.grpValue) ? obj.grpValue : obj.grpValue.split(',')
        valuesList = valuesList.filter(val => !_.isEmpty(val))
        groupingTextView = index === 0
          ? `${capitalize(obj.grpKey === ZIP ? ZIPCODE : obj.grpKey)} = ${valuesList.join()}`
          : `${groupingTextView} AND ${capitalize(obj.grpKey)} = ${_.isArray(obj.grpValue) ? obj.grpValue.join() : obj.grpValue}`
      }
    })

    groupingTextView = groupingTextView ? `( ${groupingTextView} )` : '---'
    return <Typography className={clsx(classes.label, classes.mt20, classes.groupingValue)}>{groupingTextView}</Typography>
  }

  return (
    <Box>
      <Typography className={classes.title}>Grouping Criteria</Typography>
      {renderGroupCriteria()}
      <Typography className={clsx(classes.title, classes.mt30)}>For the above criteria there are:</Typography>
      <Typography className={classes.row}>
        <Typography className={classes.label}>Systems</Typography>
        <Typography className={classes.value}>{_.get(groupingDetails, 'total_systems', 0)}</Typography>
      </Typography>
      <Typography className={classes.row}>
        <Typography className={classes.label}>Total Energy</Typography>
        <Typography className={classes.value}>{`${_.get(groupingDetails, 'total_capacity', 0)} kWh`}</Typography>
      </Typography>
      <Typography className={classes.row}>
        <Typography className={classes.label}>Total Power</Typography>
        <Typography className={classes.value}>{`${_.get(groupingDetails, 'nameplate_power', 0)} kW`}</Typography>
      </Typography>
      <Typography className={classes.row}>
        <Typography className={classes.label}>Committed Energy</Typography>
        <Typography className={classes.value}>{`${_.get(groupingDetails, 'committed_energy', 0)} kWh`}</Typography>
      </Typography>
      <Typography className={classes.row}>
        <Typography className={classes.label}>Committed Power</Typography>
        <Typography className={classes.value}>{`${_.get(groupingDetails, 'total_power', 0)} kW`}</Typography>
      </Typography>
    </Box>
  )
}

GroupingCriteria.defaultProps = {
  isEdit: false,
  vppDetails: {},
  programId: '',
  grpCriteria: [],
  accountId: ''
}

export default GroupingCriteria
